import type { SetAsideFigureResponse } from "@patent-studio/api-types";
import { Panel } from "@/components/ui/Panel";
import { Thumbnail } from "@/components/ui/Thumbnail";
import { cn } from "@/lib/utils";
import {
  DeletedFold,
  DeletedMark,
  SetAsideActs,
  type SetAsideActsProps,
} from "@/v2/figures/DeletedFigures";
import { CARD_SHAPE } from "./FigureRow";
import { FigurePreview } from "./FigurePreview";

/** Upload & Organise's list: one card per deleted figure, at the flow's card size. */
export function DeletedFigureCards({
  deleted,
  ...acts
}: SetAsideActsProps & { deleted: readonly SetAsideFigureResponse[] }) {
  return (
    <DeletedFold count={deleted.length}>
      <ul className="flex flex-col gap-2">
        {deleted.map((figure) => (
          <Panel
            key={figure.file_id}
            as="li"
            shape="row"
            pad="tight"
            data-testid={`deleted-card-${figure.file_id}`}
            tone="destructive"
            className={cn(CARD_SHAPE, "flex-wrap")}
          >
            <FigurePreview figure={figure}>
              <Thumbnail
                src={figure.thumbnail_url}
                alt={figure.original_filename}
                dimmed
              />
            </FigurePreview>
            <div className="flex min-w-0 flex-1 flex-col gap-0.5 overflow-hidden">
              <DeletedMark />
              <span className="truncate font-mono text-[11.5px] text-muted-foreground">
                {figure.original_filename}
              </span>
            </div>
            {/* On a line of their own: beside the name, in a card this narrow, they would
                crowd the file name down to a few letters. */}
            <div className="basis-full">
              <SetAsideActs figure={figure} {...acts} />
            </div>
          </Panel>
        ))}
      </ul>
    </DeletedFold>
  );
}
